// Vendors
import { useEffect, useRef } from 'react';
// Event Handlers
import { GetStateHandlers } from 'handlers/get-state.handlers';
// Types
import { GetStateHookReturnType, GetStateHookType } from 'hooks/types/get-state.hook.type';

const useAppGetStateHook = (props: GetStateHookType): GetStateHookReturnType => {
  // eslint-disable-next-line no-undef
  const timeoutRef = useRef({ current: null } as Partial<NodeJS.Timeout> as NodeJS.Timeout);
  const isMountedRef = useRef(true);

  const { handleCleanupIntervalsOnUnmount, handleGetOnboardingStateEvent } = GetStateHandlers({
    ...props,
    timeoutRef,
    isMountedRef,
  });

  useEffect(() => {
    return () => {
      handleCleanupIntervalsOnUnmount();
    };
  }, []);

  return { handleGetOnboardingStateEvent };
};

export { useAppGetStateHook };
